import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const sectionContainer = ({ backgroundColor }: { backgroundColor?: string }) => css`
  background-color: ${backgroundColor};
  padding: 48px;
  display: flex;
  width: 100%;
  display: flex;
  font-size: 16px;
  justify-content: center;
`

export const section = (theme: Theme) => css`
  max-width: 100%;
  width: 1184px;
  display: flex;
  gap: 48px;
  line-height: 180%;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${theme.palette.uintel.main};
    font-weight: 700;
    line-height: 155%;
  }

  h4 {
    margin-top: 8px;
  }

  h2 {
    font-size: 25px;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
  }
  h4 {
    color: ${theme.palette.uintel.light};
  }

  ul {
    padding-left: 28px;
  }

  i {
    color: ${theme.palette.uintel.main};
    font-size: 16px;
    font-weight: 600;
  }

  a {
    color: ${theme.palette.uintel[600]};
    font-size: 16px;
  }
`

export const rightImageStyle = css`
  max-width: 40%;
  width: 450px;
  flex-shrink: 0;

  > * {
    max-width: 100%;
  }
`

export const leftImageStyle = css`
  max-width: 40%;
  width: 450px;
  flex-shrink: 0;

  > * {
    max-width: 100%;
    border-bottom-right-radius: 60px;
  }
`

export const rightBoxStyle = (theme: Theme) => css`
  padding: 40px;
  color: #fff;
  background-color: ${theme.palette.primary.light};
  max-width: 416px;
  align-self: center;
  border-bottom-right-radius: 60px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #fff !important;
    margin-bottom: 4px;
  }
`
